export const validateNullOrEmpty = (value) => {
  if (!value) {
    return false;
  }
  return String(value).trim() !== "";
};
export const validatePhoneNumber = (phoneNumber) => {
  const phoneRegex = /^(0|\+84|84)(3|5|7|8|9)[0-9]{8}$/;
  return phoneRegex.test(phoneNumber);
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(value);
};

export const scrollToForm = () => {
  const headerHeight = document.getElementById("headerDiv")?.offsetHeight || 0;
  const div2Position =
    document.getElementById("form-contact")?.offsetTop || 0;
  const scrollPosition = div2Position - headerHeight - 80; //
  window.scrollTo({
    top: scrollPosition,
    behavior: "smooth",
  });
};
